exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vsko-pager li > a {\n    border-radius: 2px !important;\n}\n", ""]);

// exports
